// src/container/Testimonials/Testimonials.jsx
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { images } from '../../constants';
import { Tilt } from 'react-tilt';
import { useGoogleMaps } from '../../context/GoogleMapsContext'; // Adjust the path as necessary
import './Testimonials.css';
import '../Header/Header.css';

const renderStars = (rating) => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(<FontAwesomeIcon key={i} icon={faStar} color={i <= rating ? "#ffc107" : "#e4e5e9"} />);
    }
    return <div>{stars}</div>;
};

const MIN_REVIEW_RATING = 4;

const Testimonials = () => {
    const [reviews, setReviews] = useState([]);
    const [globalRating, setGlobalRating] = useState(null);
    const { isLoaded, google } = useGoogleMaps();

    useEffect(() => {
        if (isLoaded && google) {
            const mapDiv = document.createElement("div");
            mapDiv.style.display = "none";
            document.body.appendChild(mapDiv);

            const service = new google.maps.places.PlacesService(mapDiv);
            service.getDetails(
                {
                    placeId: "ChIJDXYSfYZv5kcRJBO0q5kdKeQ",
                    fields: ["reviews", "rating"],
                },
                (place, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        setReviews(place.reviews);
                        setGlobalRating(place.rating);
                    }
                }
            );

            return () => {
                document.body.removeChild(mapDiv);
            };
        }
    }, [isLoaded, google]);

    const filteredReviews = reviews.filter(
        (review) => typeof review?.rating === 'number' && review.rating >= MIN_REVIEW_RATING
    );

    const settings = {
        infinite: filteredReviews.length > 1,
        speed: 500,
        slidesToShow: Math.min(3, filteredReviews.length),
        slidesToScroll: 1,
        arrows: false,
        autoplay: filteredReviews.length > 1,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: Math.min(2, filteredReviews.length),
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const tiltOptions = {
        max: 25,
        scale: 1.05,
        speed: 1000,
        glare: true,
        "max-glare": 0.5,
    };

    return (
        <div className="testimonials-container">
            <div className={"app__engagement-content_history flex__center"}>
                <h1 className="headtext__cormorant2 mt-10">
                    Avis Google
                </h1>
                {globalRating && (
                    <div className="p__cormorant center-content" style={{color: '#FF7373'}}>
                        <h2>Note globale : {globalRating}/5</h2>
                    </div>
                )}
                <img
                    src={images.chopstickSide}
                    alt="about_chopstick"
                    className="chopstick__img"
                    style={{
                        filter: 'invert(0.5) sepia(1) saturate(5) hue-rotate(-40deg)'
                    }}
                />
            </div>

            <Slider {...settings} key={filteredReviews.length}>
                {filteredReviews?.map((review) => (
                    <Tilt className="Tilt" options={tiltOptions} key={review.id || review.time}>
                        <div className="review-card">
                            <div className="review-image-container">
                                {review.profile_photo_url && (
                                    <img
                                        src={review.profile_photo_url}
                                        alt={`${review.author_name}'s profile`}
                                        className="review-image"
                                    />
                                )}
                                <div className="review-image-placeholder">
                                    <h1>{review.author_name}</h1>
                                    {renderStars(review.rating)}
                                </div>
                            </div>
                            <div className="review-content">
                                <FontAwesomeIcon icon={faQuoteLeft} className="quote-icon top-left" />
                                <p>{review.text}</p>
                                <FontAwesomeIcon icon={faQuoteRight} className="quote-icon bottom-right" />
                            </div>
                        </div>
                    </Tilt>
                ))}
            </Slider>
            {filteredReviews.length === 0 && (
                <div className="p__cormorant center-content" style={{ color: '#FF7373', marginTop: '1rem' }}>
                    Aucun avis a {MIN_REVIEW_RATING} etoiles ou plus pour le moment.
                </div>
            )}
        </div>
    );
};

export default Testimonials;